<template>
  <div id="app" :class="app_bg">
    <!-- HEADER -->
    <div class="header">
      <div class="mx-auto text-center">
        <div class="grid grid-cols-2 sm:grid-cols-3 gap-1">
          <div class="hidden sm:grid"></div>
          <div><img src="static/img/main_logo.svg" class="mx-auto" /></div>
          <!--          current section: {{ current_section }} - popup_state{{-->
          <!--            popup_state-->
          <!--          }}-->
          <!--          - appstate:{{ app_state }} - pagestate:-->
          <!--          {{ page_state }}-->
          <div class="text-right"></div>
        </div>
      </div>
    </div>

    <!-- CONTENT AREA -->
    <router-view class="content" />

    <!-- FOOTER -->
    <transition name="fade">
      <Footer />
    </transition>

    <!-- LIST OF AVAILABLE POPUPS -->
    <transition name="fade">
      <VideoPopup v-if="popup_state == 'video'" />
      <ImagePopup v-if="popup_state == 'image'" />
      <FormPopup v-if="popup_state == 'form'" />
      <CaricatureUploadPopup v-if="popup_state == 'caricature_upload'" />
      <ExternalLinkPopup v-if="popup_state == 'external_link'" />
      <LinksPopup v-if="popup_state == 'links' || popup_state == 'pdf_list'" />
      <LinksHeaderPopup v-if="popup_state == 'links_header'" />
      <LinksSlideshowPopup v-if="popup_state == 'pdf_slideshow'" />
      <SlidePopup v-if="popup_state == 'slideshow'" />
      <InstructionsPopup v-if="popup_state == 'instructions'" />
      <ScavengerPopup v-if="popup_state == 'scavenger'" />
      <IframePopup v-if="popup_state == 'iframe'" />
    </transition>

    <!--    <QRLink />-->
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Footer from "./components/Footer";

import hotkeys from "hotkeys-js";
import queryString from "query-string";

import CaricatureUploadPopup from "./components/popups/CaricatureUploadPopup";
import ExternalLinkPopup from "./components/popups/ExternalLinkPopup";
import FormPopup from "./components/deprecated/FormPopup";
import ImagePopup from "./components/popups/ImagePopup";
import InstructionsPopup from "./components/popups/InstructionsPopup";
import LinksPopup from "./components/popups/LinksPopup";
import LinksHeaderPopup from "./components/popups/LinksHeaderPopup";
import LinksSlideshowPopup from "./components/popups/LinksSlideshowPopup";
import ScavengerPopup from "./components/popups/ScavengerPopup";
import SlidePopup from "./components/popups/SlideshowPopup";
import VideoPopup from "./components/popups/VideoPopup";
import IframePopup from "./components/popups/IframePopup";

import QRLink from "./components/misc/QRLink";

export default {
  name: "App",
  components: {
    CaricatureUploadPopup,
    ExternalLinkPopup,
    Footer,
    FormPopup,
    ImagePopup,
    InstructionsPopup,
    LinksPopup,
    LinksHeaderPopup,
    LinksSlideshowPopup,
    QRLink,
    ScavengerPopup,
    SlidePopup,
    VideoPopup,
    IframePopup
  },
  data() {
    return {
      extra_body_class: ""
    };
  },
  computed: {
    ...mapState(["app_state", "page_state", "popup_state", "current_section"]),
    app_bg() {
      var str =
        "app_bg app_state_" +
        this.$store.state.app_state +
        " page_state_" +
        +this.$store.state.page_state +
        " " +
        this.extra_body_class;

      if (
        this.$store.state.app_state >= 0 &&
        this.$store.state.page_state == 2
      ) {
        str += " active";
      }
      return str;
    }
  },
  methods: {
    is_safari(val) {
      console.log("is_safari", val);

      this.extra_body_class = " is-safari";
    },
    do_resize() {
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight / 100}px`
      );
    },
    fix_dimensions() {
      this.do_resize();
      window.addEventListener(
        "resize",
        function () {
          this.do_resize();
        }.bind(this)
      );
    }
  },
  created() {
    console.log("app mounted");
    this.$bus.$on("is-safari", this.is_safari);
  },
  mounted() {
    hotkeys(
      "ctrl+shift+x, command+shift+x",
      function () {
        console.log(this.$store.state.popup_state);
        if (
          this.$store.state.popup_state == "video" ||
          this.$store.state.popup_state == "image"
        ) {
          this.$bus.$emit("on-request-video-close", null);
        }
      }.bind(this)
    );

    this.fix_dimensions();
    try {
      var query_string = queryString.parse(location.search);

      if (
        "undefined" != typeof query_string.skipVideos &&
        query_string.skipVideos == "1"
      ) {
        this.$store.dispatch("set_simple_val", {
          name: "can_skip_videos",
          val: true
        });
      }
    } catch (e) {
      //could not parse query string
    }
  }
};
</script>

<style>
@font-face {
  font-family: RobotoPE;
  src: url(assets/font/Roboto-Regular.ttf) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: RobotoPE;
  src: url(assets/font/Roboto-Bold.ttf) format("truetype");
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: RobotoPE;
  src: url(assets/font/Roboto-Medium.ttf) format("truetype");
  font-weight: 600;
  font-style: normal;
}
#app {
  font-family: RobotoPE, "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.header {
  background: #fff;
  text-align: center;
  padding: 10px 0;
}
.header img {
  max-width: 240px;
  display: block;
}

.app_bg {
  background: #f0f0f0;
  min-height: 100vh;
  xtransition: all 1s;
}

.app_bg.active {
  background: #f0f0f0;
}
.app_bg.active .loading-app {
  display: none;
}

#app {
  display: flex;
  flex-flow: column;
  flex-shrink: 0 !important;
}
.virtual-booth-holder {
  flex: 1;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  xjustify-content: center;
}
.virtual-booth-holder > div.video-container,
.virtual-booth-holder > div.container {
  margin-top: auto;
  margin-bottom: auto;
}
.page_state_2 .virtual-booth-holder > div.unity-content-container {
  margin-top: auto;
  margin-bottom: auto;
  min-height: 100%;
  flex-grow: 1;
}
@media only screen and (max-width: 610px) {
  body .header img {
    max-width: 150px;
  }
}
@media only screen and (max-width: 1024px) {
  .hidden-container.active {
    min-height: 50vh;
  }
}
@media only screen and (min-width: 1024px) {
  .virtual-booth-holder {
    xmax-height: 100vh;
  }
}
@tailwind base;

@tailwind components;

@tailwind utilities;

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.popup {
  z-index: 500;
}

html {
  -ms-touch-action: manipulation;
  touch-action: manipulation;
}

.app_sidebar {
  display: none;
}
.app-sidebar-responsive {
  display: none;
}
.app_sidebar .guided-item.linked {
  display: none;
}

@media only screen and (max-width: 1024px) {
  .app-sidebar-instructions {
    display: none;
  }
  .app-sidebar-wrap {
    width: 90vw;
    margin-left: 5vw;
    transition: opacity 0.3s;
    opacity: 0;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
  .app_sidebar.active .app-sidebar-wrap {
    visibility: visible;
    opacity: 1;
    height: inherit !important;
  }
  .app-sidebar-wrap li.section-item {
    flex: 0;
    min-width: 100%;
    margin: 1px;
  }
  .app-sidebar-wrap li.section-item br {
    content: "";
  }
  .app-sidebar-wrap li.section-item br:after {
    content: " ";
  }
  .app_sidebar-responsive {
    display: block;
  }
  .app-sidebar-responsive {
    display: block;
  }
  .app-sidebar-responsive a {
    background: rgba(10, 10, 10, 0.7);
    color: #fff;
    display: inline-block;
    border-radius: 5px;
    padding: 15px 25px;
    margin-top: 10px;
  }
}
@media only screen and (max-height: 424px) {
  .header img {
    max-width: 90px;
  }
  .footer,
  .app_state_0.page_state_2 .footer {
    display: none;
  }
  .page_state_0 .footer,
  .page_state_1 .footer,
  .page_state_21 .footer {
    display: flex;
  }
}

@media only screen and (max-width: 700px), screen and (max-height: 700px) {
  body {
    min-height: calc(var(--vh, 1vh) * 100) !important;
  }
  .app_bg {
    min-height: calc(var(--vh, 1vh) * 100);
    xmin-height: 50vh !important;
  }
  .footer {
    display: none;
  }
  .page_state_0 .footer,
  .page_state_1 .footer,
  .page_state_21 .footer {
    display: flex;
  }

  .page_state_0 .footer ul,
  .page_state_1 .footer ul,
  .page_state_21 .footer ul {
    align-items: stretch;
  }

  .page_state_0 .footer li,
  .page_state_1 .footer li,
  .page_state_21 .footer li {
    margin: 0;
    flex: 1;
    flex-basis: 100%;
  }
  .page_state_0 .footer a,
  .page_state_1 .footer a,
  .page_state_21 .footer a {
    display: block;
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }

  .app_sidebar {
    display: block;
  }
  /*.app_state_0 .app_sidebar .section-item.linked {
    display: none;
  }*/
  .app_state_0 .app_sidebar .guided-item.linked {
    display: flex;
  }

  .app_state_2 .app_sidebar .responsive-section-item {
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue